<template>
  <div v-if="modelValue" class="mask" @click.self="close">
    <div class="dialog dialog--shell dialog--narrow">
      <div class="dialog-head">
        <h3 class="dialog-title">修改密码</h3>
        <button type="button" class="dialog-close" aria-label="关闭" @click="close">×</button>
      </div>
      <div class="dialog-body">
        <p class="sub">修改当前登录账号的密码，需验证旧密码。</p>
        <p v-if="errorMsg" class="error">{{ errorMsg }}</p>
        <div class="form">
          <label class="field">
            <span>旧密码</span>
            <input v-model="oldPassword" type="password" autocomplete="current-password" placeholder="请输入旧密码" />
          </label>
          <label class="field">
            <span>新密码</span>
            <input v-model="newPassword" type="password" autocomplete="new-password" placeholder="6-64 位" />
          </label>
          <label class="field">
            <span>确认新密码</span>
            <input v-model="newPassword2" type="password" autocomplete="new-password" placeholder="再次输入新密码" />
          </label>
        </div>
      </div>
      <div class="dialog-foot">
        <button type="button" class="btn btn-cancel" :disabled="loading" @click="close">取消</button>
        <button type="button" class="btn btn-primary" :disabled="loading" @click="onSubmit">
          {{ loading ? '保存中…' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { adminChangePassword, adminLogout, setAdminToken } from '@/api'

export default {
  name: 'ChangePasswordDialog',
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup() {
    const router = useRouter()
    return { router }
  },
  data() {
    return {
      loading: false,
      oldPassword: '',
      newPassword: '',
      newPassword2: '',
      errorMsg: '',
    }
  },
  watch: {
    modelValue(v) {
      if (v) this.resetForm()
    },
  },
  methods: {
    resetForm() {
      this.loading = false
      this.oldPassword = ''
      this.newPassword = ''
      this.newPassword2 = ''
      this.errorMsg = ''
    },
    close() {
      if (this.loading) return
      this.$emit('update:modelValue', false)
    },
    async onSubmit() {
      try {
        this.errorMsg = ''
        const oldPassword = String(this.oldPassword || '').trim()
        const newPassword = String(this.newPassword || '').trim()
        const newPassword2 = String(this.newPassword2 || '').trim()
        if (!oldPassword) throw new Error('请输入旧密码')
        if (!newPassword || newPassword.length < 6) throw new Error('新密码至少 6 位')
        if (newPassword !== newPassword2) throw new Error('两次输入的新密码不一致')

        this.loading = true
        await adminChangePassword({ oldPassword, newPassword })
        try {
          await adminLogout()
        } catch {
          // ignore
        }
        setAdminToken('')
        localStorage.removeItem('admin.profile')
        this.$emit('update:modelValue', false)
        this.router.replace('/login')
      } catch (e) {
        this.errorMsg = e?.message || '保存失败'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.mask {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.dialog {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}
.dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
}
.dialog-title {
  margin: 0;
  font-size: 16px;
}
.dialog-close {
  border: 0;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #667085;
}
.dialog-body {
  padding: 16px;
}
.sub {
  margin: 0 0 12px;
  color: #667085;
  font-size: 13px;
}
.error {
  color: #d92d20;
  margin: 0 0 10px;
  font-size: 13px;
}
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #344054;
}
.field input {
  height: 38px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
}
.dialog-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px 16px;
  border-top: 1px solid #eef2f7;
}
.btn {
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid transparent;
}
.btn-cancel {
  background: #f2f4f7;
  color: #344054;
  border-color: #e4e7ec;
}
.btn-primary {
  background: #2563eb;
  color: #fff;
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
